module.exports = __webpack_public_path__ + "static/media/play-circle.6be36531.svg";